export enum MutationKey {
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  RECOVER_PASSWORD = 'RECOVER_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
  CREATE_VACANCY = 'CREATE_VACANCY',
  DELETE_VACANCY = 'DELETE_VACANCY',
  EDIT_VACANCY = 'EDIT_VACANCY',
  UPDATE_VACANCY_RESPONSIBLE = 'UPDATE_VACANCY_RESPONSIBLE',
  UPDATE_USER = 'UPDATE_USER',
  STORAGE_UPLOADS_AVATARS = 'STORAGE_UPLOADS_AVATARS',
  STORAGE_UPLOADS_VIDEOS = 'STORAGE_UPLOADS_VIDEOS',
  UPDATE_COMPANY = 'UPDATE_COMPANY',
  CREATE_USER = 'CREATE_USER',
  AUTH_REGISTER = 'AUTH_REGISTER',
  AUTH_REGISTER_VERIFICATION = 'AUTH_REGISTER_VERIFICATION',
  AUTH_REGISTER_RESEND_CODE = 'AUTH_REGISTER_RESEND_CODE',
  AUTH_REGISTER_VERIFIED = 'AUTH_REGISTER_VERIFIED',
  AUTH_SURFER_REGISTER = 'AUTH_SURFER_REGISTER',
  AUTH_SURFER_REGISTER_VERIFICATION = 'AUTH_SURFER_REGISTER_VERIFICATION',
  AUTH_SURFER_REGISTER_RESEND_CODE = 'AUTH_SURFER_REGISTER_RESEND_CODE',
  AUTH_SURFER_REGISTER_VERIFIED = 'AUTH_SURFER_REGISTER_VERIFIED',
  UPDATE_COMPANY_ACTIVITY = 'UPDATE_COMPANY_ACTIVITY',
  UPDATE_USER_ACTIVITY = 'UPDATE_USER_ACTIVITY',
  UPDATE_VACANCY_STATUS = 'UPDATE_VACANCY_STATUS',
  CREATE_VACANCY_COPY = 'CREATE_VACANCY_COPY',
  GET_VACANCY_COPY = 'GET_VACANCY_COPY',
  GENERATE_VACANCY = 'GENERATE_VACANCY',
  UPDATE_VACANCY_CANDIDATE_DECISION = 'UPDATE_VACANCY_CANDIDATE_DECISION',
  UPDATE_CANDIDATE_INTERVIEW_REQUIRED = 'UPDATE_CANDIDATE_INTERVIEW_REQUIRED',
  UPDATE_CANDIDATE_STATUS = 'UPDATE_CANDIDATE_STATUS',
  SEND_USER_AI_MESSAGE_REQUEST = 'SEND_USER_AI_MESSAGE_REQUEST',
  UPDATE_COMPANY_NCC = 'UPDATE_COMPANY_NCC',
  UPDATE_CANDIDATE_RATING_STATUS = 'UPDATE_CANDIDATE_RATING_STATUS',
  SUBMIT_INTERVIEW_CANCELLATION = 'SUBMIT_INTERVIEW_CANCELLATION',
  SUBMIT_CANDIDATE_RATING_REJECTION = 'SUBMIT_CANDIDATE_RATING_REJECTION',
  SUBMIT_CANDIDATE_RATING_REVIEW = 'SUBMIT_CANDIDATE_RATING_REVIEW',
}
